module.exports = __webpack_public_path__ + "media/images/medal-7f98ce8a0fe44d15b6cb278548b6254d.svg";